<template>
  <router-link
    v-if="project.actionsAvailable"
    :to="projectDetailsRoute(project)"
  >
    <v-icon color="primary">
      mdi-bell-ring
    </v-icon>
  </router-link>
</template>

<script>
import projectFormattedInfo from '@/mixins/projectFormattedInfo.vue';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  mixins: [
    projectFormattedInfo, // projectDetailsRoute
  ],
};
</script>
